export default __webpack_public_path__ + "static/media/PayPal.564d0cc1.svg";